import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import {  TextField } from "@mui/material";


RHFTextField.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFTextField({
  name,
  helperText,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
        <TextField
          {...field}
          fullWidth
          value={field.value !== undefined ? field.value : ""}
          error={!!error}
          helperText={error ? error?.message : helperText}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 0,
              backgroundColor: "#B9E3F0",
              fontSize: "1.6rem",
              boxShadow: "0px 4px 13px rgba(0, 0, 0, 0.27)",
              position: "relative",
              "&::before": {
                content: "''",
                position: "absolute",
                left: "0",
                top: "50%",
                transform: "translateY(-50%)",
                width: "8px",
                height: "100%",
                backgroundColor: "#146482",
                
                zIndex: 1000
              }
            },
            "& .MuiFormHelperText-root": {
              color: "red",
              fontSize: "1.2rem", 
              marginLeft: "8px", 
            },
          }}
          {...other}
        />
        </>

      )}
    />
  );
}
